import { getInitialState, getPath } from "../../utils";
import ActionTypes from "../actions/ActionTypes";

const initialState = {
    platformFeeDetails: {},
    activeFilters: {},
};

export default function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.SET_PLATFORM_FEE_DETAILS:
            return setPlatformFeeDetails(state, action);
        case ActionTypes.RESET_STATE_PLATFORM_FEE_DETAILS:
            return resetState(state, action);
        case ActionTypes.SET_PLATFORM_FEE_DETAILS_ACTIVE_FILTERS:
            return setActiveFilters(state, action);
        default:
            return state;
    }
}
const setPlatformFeeDetails = (state, action) => {
    return {
        ...state,
        platformFeeDetails: action.payload
    };
};

const resetState = (state, action) => {
    if (action.payload.state) {
        return {
            ...state,
            [action.payload.state]: getInitialState(
                initialState,
                action.payload.state
            ),
        };
    } else {
        return initialState;
    }
};

const setActiveFilters = (state, action) => {
    return {
        ...state,
        activeFilters: action.payload,
    };
};
